import { render, staticRenderFns } from "./oil.loading.vue?vue&type=template&id=d99dbc2c&"
import script from "./oil.loading.vue?vue&type=script&lang=js&"
export * from "./oil.loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports